import React, { useEffect, useState, useRef } from "react";
import "ol/ol.css";
import "ol-ext/dist/ol-ext.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { Map, View } from "ol";
import { defaults as defaultControls } from "ol/control";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import XYZ from "ol/source/XYZ";
import BingMaps from "ol/source/BingMaps";
import { Fill, Stroke, Style } from "ol/style";
import Circle from "ol/style/Circle";
import Text from "ol/style/Text.js";
import Select from "ol/interaction/Select";
import { click } from "ol/events/condition";
import { Draw } from "ol/interaction";
import ControlBar from "ol-ext/control/Bar";
import Toggle from "ol-ext/control/Toggle";
import Button from "ol-ext/control/Button";
import Modify from "ol/interaction/Modify";
import Translate from "ol/interaction/Translate";
import Dialog from "ol-ext/control/Dialog";
import FillPattern from "ol-ext/style/FillPattern";
import LayerSwitcher from "ol-ext/control/LayerSwitcher";
import LayerSwitcherImage from "ol-ext/control/LayerSwitcherImage";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import FeaturePopup from "./FeaturePopup"; // Import the new FeaturePopup component
import { GeoJSON, GPX, KML } from "ol/format";
import { fromLonLat, transform } from "ol/proj";
import * as turf from "@turf/turf";
import axios from "axios";
import qs from "qs";
import osmtogeojson from 'osmtogeojson';
import logger from '../logger';
import { generateDialog, handleFileUploadDialog, generateSourceDialog, generateLayerDialog, generateEditSourceDialog, generateEditLayerDialog } from "../utils/dialogUtil";
import LoadingIcon from "./LoadingIcon";
import { fetchSources, fetchLayers, fetchFeatures, fetchSourceParameters } from '../services/api';
import api from '../services/auth';
import MousePosition from 'ol/control/MousePosition';
import { createStringXY } from 'ol/coordinate';
import ScaleLine from 'ol/control/ScaleLine';
import SideBar from './SideBar';
import "../App.css";



const UserDefinedData = () => {

  const [location, setLocation] = useState({
    longitude: 11.028995965569194,
    latitude: 46.05321545463036,
  });

  //Samaria coordinates

  const [point, setPoint] = useState({
    longitude: 23.9624732,
    latitude: 35.2682355,
  });

  const [range, setRange] = useState(25000);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [data, setData] = useState(null);
  const mapRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [sources, setSources] = useState([]);
  const [layers, setLayers] = useState([]);
  const [features, setFeatures] = useState([]);
  const [sourceParams, setSourceParams] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('access'));
  const [isDrawerOpen, setDrawerOpen] = useState(true);
  const [hoveredButtonInfo, setHoveredButtonInfo] = useState('<strong>Hover over a button to see its details</strong>'); // State for hover information
  const [hoverLock, setHoverLock] = useState(false); // State to lock hover info
  const [showDialog, setShowDialog] = useState(false);
  const showDialogRef = useRef(false);  // Ref to track dialog state

  // Refs for vector sources
  const pharmaciesRef = useRef(null);
  const hospitalsRef = useRef(null);
  const fireStationsRef = useRef(null);
  const fireExtinguishersRef = useRef(null);
  // const nonFuelRef = useRef(null);  
  // const wifiRef = useRef(null);
  // const oxygenMasksRef = useRef(null);
  // const assemblyPointsRef = useRef(null);
  // const wildLifeRef = useRef(null);
  // const controlBarRef = useRef(null);
  const fireRef = useRef(null);
  const selectToViewRef = useRef(null);
  const hoverLockRef = useRef(false);  // Use a ref to track hover lock state
  const popupOverlayRef = useRef(null);


  const mapFeatureAttributes = (features, sources, sourceParams) => {
    // Create lookup maps for source types and sources for quick access
    const sourceTypeMap = (sourceParams?.source_types || []).reduce((map, type) => {
      map[type.id] = type.title; // Map ID to title
      return map;
    }, {});

    const sourceMap = (sources || []).reduce((map, source) => {
      map[source.id] = {
        title: source.title,
        type: source.type,
      };
      return map;
    }, {});

    // Map features to include readable attributes
    return features.map(feature => {
      const enrichedSources = feature.sources.map(sourceId => {
        const source = sourceMap[sourceId];
        if (!source) {
          return { id: sourceId, title: "Unknown Source" };
        }
        return {
          id: sourceId,
          title: source.title,
          type: sourceTypeMap[source.type] || "Unknown Type",
        };
      });

      return {
        ...feature,
        enrichedSources, // Add the enriched sources
      };
    });
  };

  // Monitor `showDialog` state to control hover behavior and locking
  useEffect(() => {
    if (showDialog) {
      setHoverLock(true);
      hoverLockRef.current = true;  // Use ref to immediately reflect hover lock
      showDialogRef.current = true;  // Update showDialogRef when dialog is shown
    } else {
      setHoverLock(false);
      hoverLockRef.current = false; // Unlock hover immediately
      showDialogRef.current = false; // Update showDialogRef when dialog is hidden
    }
  }, [showDialog]);

  // Function to safely update dialog state
  const setDialogOpen = (open) => {
    setShowDialog(open);
    showDialogRef.current = true;  // Ensure ref is always in sync
  };

  const overpassQuery = `[out:json];
      (
          nwr["healthcare"="hospital"](around:${range},${point.latitude},${point.longitude});
          nwr["healthcare"="clinic"](around:${range},${point.latitude},${point.longitude});
          nwr["amenity"="pharmacy"](around:${range},${point.latitude},${point.longitude});
          nwr["healthcare"="pharmacy"](around:${range},${point.latitude},${point.longitude});
          nwr["emergency"="fire_extinguisher"](around:${range},${point.latitude},${point.longitude});
          nwr["building"="yes"]["amenity"="fire_station"](around:${range},${point.latitude},${point.longitude});
      );
      out geom;`;

  const isToday = (selectedDate) => {
    const today = new Date().toISOString().split('T')[0];
    return selectedDate.split('-')[0] === today.split('-')[0];
  };

  const updateHoverButtonInfo = (content, forceUpdate = false) => {
    // Use showDialogRef for immediate access to dialog state
    if (!hoverLockRef.current || forceUpdate) {
      if (!showDialogRef.current) {  // Prevent updating hover info if dialog is open
        setHoveredButtonInfo(content);
      }
    }
  };

  const toggleDrawer = () => {
    setDrawerOpen((prevState) => {
      const newState = !prevState;
      logger.log("is drawer open: ", newState);
      return newState;
    });
  };

  const transformOhsomeToOsm = (ohsomeData) => {
    if (!ohsomeData.features) {
      logger.error('No features found in the Ohsome data.');
      return { elements: [] };
    }
    return {
      elements: ohsomeData.features.map((feature) => {
        if (!feature.properties['@osmId'] || !feature.geometry) {
          return null;
        }
        const [type, id] = feature.properties['@osmId'].split('/');
        const element = {
          type: type,
          id: parseInt(id),
          tags: { ...feature.properties, origin: 'Ohsome API' } || {},
        };
        if (feature.geometry.type === 'Point') {
          element.lat = feature.geometry.coordinates[1];
          element.lon = feature.geometry.coordinates[0];
        } else if (feature.geometry.type === 'LineString') {
          const coordinates = feature.geometry.coordinates;
          element.geometry = coordinates.map((coordinate) => ({
            lat: coordinate[1],
            lon: coordinate[0],
          }));
          const latitudes = coordinates.map(coord => coord[1]);
          const longitudes = coordinates.map(coord => coord[0]);
          element.bounds = {
            minlat: Math.min(...latitudes),
            minlon: Math.min(...longitudes),
            maxlat: Math.max(...latitudes),
            maxlon: Math.max(...longitudes),
          };
        } else if (feature.geometry.type === 'Polygon') {
          const coordinates = feature.geometry.coordinates[0];
          element.geometry = coordinates.map((coordinate) => ({
            lat: coordinate[1],
            lon: coordinate[0],
          }));
          const latitudes = coordinates.map(coord => coord[1]);
          const longitudes = coordinates.map(coord => coord[0]);
          element.bounds = {
            minlat: Math.min(...latitudes),
            minlon: Math.min(...longitudes),
            maxlat: Math.max(...latitudes),
            maxlon: Math.max(...longitudes),
          };
        }
        if (type === 'relation') {
          element.members = [
            {
              type: "way", //feature.geometry.type,
              role: "outer",
              ref: parseInt(id),
              geometry: feature.geometry.coordinates[0].map(coord => ({
                lat: coord[1],
                lon: coord[0],
              })),
            }
          ];
          delete element.geometry;
        }
        return element;
      }).filter(element => element !== null),
    };
  };

  useEffect(() => {
    setData(null);
    setLoading(true);

    const fetchData = async () => {
      try {
        let geojson;

        if (isToday(selectedDate)) {
          const response = await axios.get(`${process.env.REACT_APP_OVERPASS_API}/api/interpreter?data=${encodeURIComponent(overpassQuery)}`);
          logger.log("Received Overpass Data:", response.data);

          const convertedData = osmtogeojson(response.data);

          const transformedFeatures = convertedData.features.map(feature => {
            if (feature.geometry.type === 'Polygon') {
              // Check if the feature is a hospital or pharmacy
              if (['hospital', 'clinic', 'pharmacy'].includes(feature.properties.amenity) || ['hospital', 'clinic', 'pharmacy'].includes(feature.properties.healthcare)) {
                // Calculate the centroid and convert to a point
                const centroid = turf.centroid(feature);
                return {
                  type: 'Feature',
                  geometry: {
                    type: 'Point',
                    coordinates: centroid.geometry.coordinates,
                  },
                  properties: feature.properties,
                };
              }
            }
            return feature;
          });

          geojson = {
            type: 'FeatureCollection',
            features: transformedFeatures,
          };

          logger.log("Transformed Overpass Data: ", geojson);
        } else {
          const year = selectedDate.getFullYear();
          const startDate = `${year}-01-01`;
          const endDate = `${year}-12-31`;
          const requestData = {
            bcircles: `${point.longitude},${point.latitude},${range}`,
            time: `${startDate},${endDate}`,
            showMetadata: 'yes',
            properties: 'metadata,tags',
            filter: `healthcare=hospital or healthcare=clinic or amenity=pharmacy or healthcare=pharmacy or emergency=fire_extinguisher or (building=yes and amenity=fire_station)`,
          };
          const response = await axios.post(`${process.env.REACT_APP_OHSOME_API}`,
            qs.stringify(requestData),
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
          );
          logger.log("Received Ohsome Data: ", response.data);

          const transformedData = transformOhsomeToOsm(response.data);

          logger.log("Transformed Ohsome Data: ", transformedData);
          geojson = osmtogeojson(transformedData);

          const transformedFeatures = geojson.features.map(feature => {
            if (feature.geometry.type === 'Polygon') {
              // Check if the feature is a hospital or pharmacy
              if (['hospital', 'clinic', 'pharmacy'].includes(feature.properties.amenity) || ['hospital', 'clinic', 'pharmacy'].includes(feature.properties.healthcare)) {
                // Calculate the centroid and convert to a point
                const centroid = turf.centroid(feature);
                return {
                  type: 'Feature',
                  geometry: {
                    type: 'Point',
                    coordinates: centroid.geometry.coordinates,
                  },
                  properties: feature.properties,
                };
              }
            }
            return feature;
          });

          geojson = {
            type: 'FeatureCollection',
            features: transformedFeatures,
          };

          logger.log("Converted Ohsome Data: ", geojson);
        }

        setData(geojson);
      } catch (error) {
        logger.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    // Clean up interactions only if necessary
    return () => {
      mapRef.current.getInteractions().clear();
    };

  }, [selectedDate]);

  const fetchAndSetData = async () => {
    try {
      const [sourcesData, layersData, featuresData, sourceParamsData] = await Promise.all([
        fetchSources(),
        fetchLayers(),
        fetchFeatures(),
        fetchSourceParameters()
      ]);

      // Map the features to include readable attributes
      const enrichedFeatures = mapFeatureAttributes(featuresData, sourcesData, sourceParamsData);

      // Set state with enriched data
      setSources(sourcesData);
      setLayers(layersData);
      setFeatures(enrichedFeatures); // Use enriched features here
      setSourceParams(sourceParamsData);

      // logger.log("Fetched Sources From DB: ", sourcesData);
      // logger.log("Fetched Layers From DB: ", layersData);
      // logger.log("Fetched Features From DB: ", enrichedFeatures);
      // logger.log("Fetched Source Parameters From DB: ", sourceParamsData);
    } catch (error) {
      logger.error('Error fetching and setting data:', error);
    }
  };

  useEffect(() => {
    if (loading) return; // Prevent map setup until all data is loaded
  
    const initializeMap = async () => {
      try {
        // Load saved BBOX from localStorage if available
        const savedBbox = localStorage.getItem("mapBbox");
  
        const map = new Map({
          target: "map",
          controls: defaultControls({ zoom: false }).extend([
            new ScaleLine({
              units: "metric",
              bar: true,
              steps: 4,
              text: true,
              minWidth: 140,
              maxWidth: 140,
            }),
            new MousePosition({
              coordinateFormat: createStringXY(4),
              projection: "EPSG:4326",
              className: "mouse-position",
              target: document.getElementById("mouse-position"),
              undefinedHTML: "&nbsp;",
            }),
          ]),
          layers: [
            new TileLayer({
              source: new OSM(),
              title: "Map",
              displayInLayerSwitcher: false,
              displayInLayerSwitcherImage: true,
            }),
          ],
          view: new View({
            center: fromLonLat([location.longitude, location.latitude]),
            zoom: 5,
          }),
        });
  
        mapRef.current = map;
  
        // Apply saved BBOX only after the map view is ready
        if (savedBbox) {
          setTimeout(() => {
            const bbox = JSON.parse(savedBbox);
            const extent = bbox.map((coord) => parseFloat(coord));
            map.getView().fit(extent, { size: map.getSize() });
          }, 500);
        }
  
        // Save the current BBOX to localStorage whenever the map is moved or zoomed
        map.on("moveend", () => {
          const extent = map.getView().calculateExtent(map.getSize());
          localStorage.setItem("mapBbox", JSON.stringify(extent));
        });
  
        // Initialize selection interaction
        selectToViewRef.current = new Select({});
        if (selectToViewRef.current) {
          map.addInteraction(selectToViewRef.current);
        }
  
        // Check if user is logged in before fetching data
        if (localStorage.getItem("access")) {
          await fetchAndSetData(); // Fetch sources, layers, and features
          const combinedSources = await combineSourcesWithCategories();
  
          // Assign tile layers to LayerSwitcherImage
          assignTileLayerToLayerSwitcherImage(combinedSources, map);
  
          // Initialize LayerSwitcherImage
          const layerSwitcherImage = new LayerSwitcherImage({
            reordering: false,
            mouseover: false,
            collapsed: true,
            toggleOne: true,
            displayInLayerSwitcher: (layer) => layer instanceof TileLayer,
          });
  
          map.addControl(layerSwitcherImage);
          layerSwitcherImage.element.className += " custom-layer-switcher-image";
  
          // Function to set a default image for the main button
          const setDefaultMainButtonImage = () => {
            const mainButton = document.querySelector(".ol-layerswitcher-image > button");
            if (mainButton) {
              mainButton.style.backgroundImage = "url(https://tile.openstreetmap.org/10/512/349.png)";
              mainButton.style.backgroundSize = "cover";
              mainButton.style.backgroundColor = "transparent";
              mainButton.textContent = "";
              mainButton.title = "Map"; // Default tooltip
            }
          };
  
          // Function to update the main button image based on the selected layer
          const updateMainButtonImage = (layer) => {
            const mainButton = document.querySelector(".ol-layerswitcher-image > button");
            if (!mainButton) return;
  
            const listItem = Array.from(document.querySelectorAll(".ol-imgcontainer"))
              .find((li) => li.querySelector("p").textContent.trim() === layer.get("title"));
  
            if (listItem) {
              const imgElement = listItem.querySelector("img");
              if (imgElement && imgElement.src) {
                mainButton.style.backgroundImage = `url(${imgElement.src})`;
                mainButton.style.backgroundSize = "cover";
                mainButton.style.backgroundColor = "transparent";
                mainButton.textContent = "";
                mainButton.title = layer.get("title").replace(/^TS - /, "");
                return;
              }
            }
  
            setDefaultMainButtonImage();
          };
  
          // Ensure the button is always visible
          const ensureButtonVisible = () => {
            const mainButton = document.querySelector(".ol-layerswitcher-image > button");
            if (mainButton) {
              mainButton.style.display = "block";
              mainButton.style.opacity = "1";
              mainButton.style.visibility = "visible";
            }
          };
  
          // Update main button image after render
          layerSwitcherImage.once("rendercomplete", ensureButtonVisible);
          layerSwitcherImage.on("collapse", ensureButtonVisible);
          layerSwitcherImage.on("expand", ensureButtonVisible);
  
          // Set initial layer image
          setTimeout(() => {
            const initialLayer = map.getLayers().getArray().find((layer) => layer.getVisible());
            if (initialLayer) {
              updateMainButtonImage(initialLayer);
            } else {
              setDefaultMainButtonImage();
            }
          }, 500);
  
          // Handle layer visibility toggle
          let isTogglingLayer = false;
          layerSwitcherImage.on("layer:visible", (evt) => {
            if (isTogglingLayer) return;
            isTogglingLayer = true;
  
            const selectedLayer = evt.layer;
            map.getLayers().forEach((l) => {
              if (l === selectedLayer) {
                l.setVisible(true);
                updateMainButtonImage(l);
              } else if (l.get("displayInLayerSwitcherImage")) {
                l.setVisible(false);
              }
            });
  
            isTogglingLayer = false;
            layerSwitcherImage.render();
            document.querySelector(".ol-layerswitcher-image").classList.add("collapsed");
          });
        }
      } catch (error) {
        console.error("Error initializing the map:", error);
      }
    };
  
    initializeMap();
  }, [loading]);  

  const createSourcesFromData = () => {
    if (!sources || !sourceParams || !sourceParams.source_types) return [];

    const sourceTypesMap = sourceParams.source_types.reduce((map, type) => {
      map[type.id] = type.title;
      return map;
    }, {});

    return sources
      .filter(source => source.is_enabled) // Only process sources where is_enabled is true
      .map(source => {
        const sourceTypeTitle = sourceTypesMap[source.type];
        if (!sourceTypeTitle) {
          logger.error(`Unsupported source type ID: ${source.type}`);
          return null;
        }

        let olSource;
        switch (sourceTypeTitle) {
          case 'Vector (Vector)':
            olSource = new VectorSource({
              attributions: source.attribution,
              // More properties can be added here
            });
            break;
          case 'OSM (Tile)':
            olSource = new OSM({
              attributions: source.attribution,
              displayInLayerSwitcherImage: true,
            });
            break;
          case 'Bing Maps (Tile)':
            olSource = new BingMaps({
              // key: options.key, (key can be added dynamically if needed)
              // imagerySet: options.imagerySet, (same for imagery set)
            });
            break;
          case 'XYZ (Tile)':
            olSource = new XYZ({
              url: '', // The actual URL should be defined here
              tileSize: 256,
              attributions: source.attribution,
            });
            break;
          default:
            logger.error(`Unsupported source type title: ${sourceTypeTitle}`);
            return null;
        }

        return { ...source, olSource };
      })
      .filter(source => source !== null);
  };

  library.add(fas, far, fab);

  function getFaUnicode(faClass) {
    // Split the class string into an array of individual class names
    const classParts = faClass.split(' ');

    // Find the style prefix (e.g., 'fas', 'far', 'fab')
    const stylePrefix = classParts.find(part => part.startsWith('fas') || part.startsWith('far') || part.startsWith('fab'));

    // Find the icon name part (e.g., 'fa-user') and remove the 'fa-' prefix
    const iconNamePart = classParts.find(part => part.startsWith('fa-') && part !== stylePrefix);

    // Check if we found a valid style prefix and icon name
    if (!stylePrefix || !iconNamePart) {
      return '';  // Return an empty string if the class string is invalid
    }

    const iconName = iconNamePart.replace('fa-', '');
    // logger.log("icon name: ", iconName);
    // Determine the correct library based on the style
    const styleMap = {
      'fas': 'fas',
      'far': 'far',
      'fab': 'fab',
    };

    const style = styleMap[stylePrefix];

    const iconDefinition = library.definitions[style][iconName];

    if (iconDefinition) {
      return String.fromCharCode(parseInt(iconDefinition[3], 16)).toLowerCase();
    }


    // logger.error(`Icon "${iconName}" not found in style "${style}".`);
    return ''; // Return an empty string if the icon is not found
  }

  const getLineDash = (line) => {
    let lineDash = [];

    switch (line) {
      case 'dashed':
        lineDash = [10, 5]; // 10px dashes with 5px gaps
        break;
      case 'dotted':
        lineDash = [2, 2];  // 2px dashes with 2px gaps
        break;
      case 'solid':
      default:
        lineDash = []; // Solid line
        break;
    }

    return lineDash;
  }

  const createStyleFromLayer = (layer) => {
    const fillColor = layer.background || 'rgba(255, 255, 255, 0.6)';
    const patternColor = layer.color || '#319FD3';
    const pattern = layer.pattern || 'none';
    const faClass = layer.icon;
    const unicodeChar = getFaUnicode(faClass);
    const lineDash = getLineDash(layer.line)


    return function (feature) {
      const geometryType = feature.getGeometry().getType();

      switch (geometryType) {
        case 'Point':
        case 'MultiPoint':
          return new Style({
            image: new Circle({
              radius: 13,
              fill: new Fill({
                color: fillColor,
              }),
              stroke: new Stroke({
                color: patternColor,
                width: 2,
                lineDash: lineDash,
              }),
            }),
            text: new Text({
              text: unicodeChar,
              scale: 1,
              font: '900 15px "Font Awesome 5 Free"',
              textAlign: 'center',
              fill: new Fill({
                color: patternColor,
              }),
            }),
          });

        case 'LineString':
        case 'MultiLineString':
          return new Style({
            stroke: new Stroke({
              color: patternColor,
              width: 4,
              lineDash: lineDash,
            }),
          });

        case 'Polygon':
        case 'MultiPolygon':
          return new Style({
            fill: new FillPattern({
              pattern: pattern,
              color: patternColor,
              fill: new Fill({
                color: fillColor,
              }),
              size: 10,
              width: 1,
            }),
            stroke: new Stroke({
              color: patternColor,
              width: 2,
              lineDash: lineDash,
            }),
            text: new Text({
              text: unicodeChar,
              scale: 1,
              font: '900 15px "Font Awesome 5 Free"',
              textAlign: 'center',
              fill: new Fill({
                color: patternColor,
              }),
            }),
          });

        default:
          return new Style({
            fill: new Fill({
              color: fillColor,
            }),
            stroke: new Stroke({
              color: patternColor,
              width: 2,
            }),
            text: new Text({
              text: unicodeChar,
              scale: 1,
              font: '900 15px "Font Awesome 5 Free"',
              textAlign: 'center',
              fill: new Fill({
                color: '#000',
              }),
            }),
          });
      }
    };

  };

  const isColorCloseToWhite = (color) => {
    let r, g, b;

    if (color.startsWith('#')) {
      // Convert hex to RGB
      const hex = color.replace('#', '');
      r = parseInt(hex.length === 3 ? hex[0] + hex[0] : hex.substring(0, 2), 16);
      g = parseInt(hex.length === 3 ? hex[1] + hex[1] : hex.substring(2, 4), 16);
      b = parseInt(hex.length === 3 ? hex[2] + hex[2] : hex.substring(4, 6), 16);
    } else if (color.startsWith('rgb')) {
      // Extract RGB values from rgb/rgba format
      const rgbValues = color.match(/\d+/g);
      r = parseInt(rgbValues[0], 10);
      g = parseInt(rgbValues[1], 10);
      b = parseInt(rgbValues[2], 10);
    } else {
      // Return false if color format is not recognized
      return false;
    }

    // Calculate brightness (0 is black, 255 is white)
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // If brightness is high (close to white), return true
    return brightness > 240;
  };

  const createLayersFromData = (createdSources) => {
    // logger.log("Created Sources: ", createdSources);
    if (!layers || !createdSources) return [];

    return layers.map(layer => {
      const sourceWithOlSource = createdSources.find(src => src.id === layer.source);
      if (!sourceWithOlSource) return null;

      const { olSource } = sourceWithOlSource;

      const style = createStyleFromLayer(layer);

      let colorForTitle = layer.color;
      if (isColorCloseToWhite(layer.color)) {
        colorForTitle = layer.background;
      }

      let olLayer;
      // Check if the source is a vector source (it will have the method `addFeatures`)
      if (olSource instanceof VectorSource) {
        // Determine if the layer title starts with "GPS" or "IPS"
        const shouldBeHidden = layer.title.startsWith("GPS") || layer.title.startsWith("IPS");

        olLayer = new VectorLayer({
          source: olSource,
          style: style,
          opacity: parseFloat(layer.opacity) || 1,
          visible: shouldBeHidden ? false : true,  // Set visibility based on title
          title: `<div style="color:${colorForTitle}"><i class="${layer.icon}"></i> ${layer.title}</div>`,
          zIndex: 9999,
        });

        // Add features to the vector source if there are any
        const featuresForLayer = features.filter(feature => feature.layer === layer.id);
        const geojsonFormat = new GeoJSON();
        const olFeatures = geojsonFormat.readFeatures({
          type: 'FeatureCollection',
          features: featuresForLayer.map(f => JSON.parse(f.geometry))
        }, {
          featureProjection: 'EPSG:3857',
        });

        olSource.addFeatures(olFeatures);
      } else {
        // If the source is not a vector source, throw an error or log the issue
        const errorMessage = `Layer "${layer.title}" has a non-vector source (e.g., OSM, XYZ, or BingMaps). Vector features cannot be added to tile layers.`;
        logger.error(errorMessage);

        // return null to skip creating the layer
        return null;
      }

      return olLayer;
    }).filter(layer => layer !== null);
  };

  const combineSourcesWithCategories = async () => {
    try {
      const sources = await fetchSources();
      const parameters = await fetchSourceParameters(); // Fetch projections and types
      // logger.log("Combining sources with parameters");

      // Create a map of projection systems by ID for easy lookup
      const projectionMap = (parameters.projection_systems || []).reduce((map, proj) => {
        map[proj.id] = proj.title;
        return map;
      }, {});

      // Create a map of source types by ID for easy lookup
      const sourceTypeMap = (parameters.source_types || []).reduce((map, type) => {
        map[type.id] = { title: type.title, options: type.options };
        return map;
      }, {});

      // Combine sources with their corresponding parameters
      const combinedData = sources.map(source => {
        const projection = projectionMap[source.projection];
        const sourceType = sourceTypeMap[source.type];

        if (!sourceType) {
          logger.error(`Source type not found for source ID: ${source.id}`);
          return null;
        }

        const sourceOptions = source.options.reduce((acc, option) => {
          acc[option.title] = option.value;
          return acc;
        }, {});

        // logger.log(`Source: ${source.title}`, { projection, sourceType, sourceOptions });

        return {
          ...source,
          projection, // Add projection title to source
          sourceType, // Add source type details
          sourceOptions, // Add source options
        };
      }).filter(source => source !== null);

      // logger.log("Combined sources with parameters:", combinedData);
      return combinedData;

    } catch (error) {
      logger.error('Error combining sources with parameters:', error);
      throw error;
    }
  };

  const assignTileLayerToLayerSwitcherImage = (combinedSources, map) => {
    logger.log("Starting assignment to LayerSwitcherImage");

    combinedSources
      .filter(source => source.is_enabled)  // Only process enabled sources
      .forEach(source => {
        // logger.log("Processing source:", source);

        let layer;
        if (source.sourceType.title.includes('Tile')) {
          // Create a TileLayer for tile-based sources
          layer = new TileLayer({
            source: new XYZ({
              url: source.sourceOptions.url,
              tileSize: parseInt(source.sourceOptions.tileSize) || 256,
              attributions: source.attribution,
            }),
            title: source.title,
            visible: false,
            displayInLayerSwitcherImage: true,
            displayInLayerSwitcher: false,
          });
        } else {
          return;
        }

        // Add the layer to the map
        map.addLayer(layer);
      });

    logger.log("Finished assigning layers to LayerSwitcherImage");
  };

  const addFeaturesToSources = (featuresData, sources, selectedDate) => {
    const geojsonFormat = new GeoJSON();

    featuresData.forEach((featureData) => {
      // Check if the feature is enabled before processing
      if (featureData.is_enabled) {
        const feature = geojsonFormat.readFeature(featureData.geometry, {
          featureProjection: 'EPSG:3857',
        });

        const validFrom = featureData.valid_from ? new Date(featureData.valid_from).toISOString().split('T')[0] : new Date('1900-01-01').toISOString().split('T')[0];
        const validTo = featureData.valid_to ? new Date(featureData.valid_to).toISOString().split('T')[0] : new Date('3000-12-31').toISOString().split('T')[0];

        // logger.log("selected date: ", selectedDate);
        // logger.log("valid from: ", validFrom);
        // logger.log("valid to: ", validTo);


        if (selectedDate >= validFrom && selectedDate <= validTo) {  
          // Add any properties to the feature as needed
          const properties = {
            id: featureData.id,
            title: featureData.title,
            description: featureData.description,
            address: featureData.address,
            contact: featureData.contact,
            valid_from: featureData.valid_from,
            valid_to: featureData.valid_to,
            owner: featureData.owner,
            type: featureData.type,
            sources: featureData.sources,
            // Add more properties as needed, avoiding conflicts with reserved names
          };

          // Set the properties on the feature
          feature.setProperties(properties);

          // Iterate through the source IDs associated with this feature
          featureData.sources.forEach((sourceId) => {
            const source = sources.find((src) => src.id === sourceId);

            // Ensure the source exists, is enabled, and has the `addFeature` method
            if (source && source.olSource && typeof source.olSource.addFeature === 'function') {
              source.olSource.addFeature(feature);  // Add the feature only to valid sources
            } else {
              logger.error(`Source with ID ${sourceId} is not a vector source or does not support addFeature.`);
            }
          });
        };
      }
    });
  };

  useEffect(() => {

    let dialogOpen = false; // Flag to track if a dialog is already open

    mapRef.current.getAllLayers().forEach((layer) => {
      // Check if the layer is a tile layer and has the 'displayInLayerSwitcherImage' flag set to true
      const isTileLayerInSwitcherImage = layer instanceof TileLayer && layer.get('displayInLayerSwitcherImage');

      // Only remove the layer if it's NOT in the LayerSwitcherImage
      if (!isTileLayerInSwitcherImage && layer.get("title") !== "Map") {
        mapRef.current.removeLayer(layer);
      }
    });

    // logger.log("features fetched: ", features);
    // logger.log("fetched Layers: ", layers);

    const createdSources = createSourcesFromData();
    createdSources.forEach(source => {
      const layer = layers.find(layer => layer.source === source.id);
      if (layer) {
        const style = createStyleFromLayer(layer);
        // addPolygonFeature(source, style);
      }
    });

    const olLayers = createLayersFromData(createdSources);

    olLayers.forEach(layer => {
      mapRef.current.addLayer(layer);
    });

    addFeaturesToSources(features, createdSources, selectedDate);

    //Styles

    const featureStyles = {
      hospital: new Style({
        image: new Circle({
          radius: 13,
          fill: new Fill({ color: "rgba(195, 166, 0, 0.8)" }),
          stroke: new Stroke({ color: "white", width: 2 }),
        }),
        text: new Text({
          text: "\uf7f2",
          scale: 0.8,
          font: '900 15px "Font Awesome 5 Free"',
          offsety: -10,
          offsetx: -10,
          textAlign: "center",
          fill: new Fill({ color: "white" }),
        }),
      }),
      clinic: new Style({
        image: new Circle({
          radius: 13,
          fill: new Fill({ color: "rgba(195, 166, 0, 0.8)" }),
          stroke: new Stroke({ color: "white", width: 2 }),
        }),
        text: new Text({
          text: "\uf7f2",
          scale: 0.8,
          font: '900 15px "Font Awesome 5 Free"',
          offsety: -10,
          offsetx: -10,
          textAlign: "center",
          fill: new Fill({ color: "white" }),
        }),
      }),
      pharmacy: new Style({
        image: new Circle({
          radius: 13,
          fill: new Fill({ color: "rgba(103,161,43, 0.8)" }),
          stroke: new Stroke({ color: "white", width: 2 }),
        }),
        text: new Text({
          text: "\uf479",
          scale: 0.8,
          font: '900 15px "Font Awesome 5 Free"',
          offsety: -10,
          offsetx: -10,
          textAlign: "center",
          fill: new Fill({ color: "white" }),
        }),
      }),
      fire_station: new Style({
        image: new Circle({
          radius: 13,
          fill: new Fill({ color: "rgba(0, 0, 255, 0.8)" }),
          stroke: new Stroke({ color: "white", width: 2 }),
        }),
        text: new Text({
          text: "\uf46a",
          scale: 0.8,
          font: '900 15px "Font Awesome 5 Free"',
          offsety: -10,
          offsetx: -10,
          textAlign: "center",
          fill: new Fill({ color: "white" }),
        }),
      }),
      fire_extinguisher: new Style({
        image: new Circle({
          radius: 13,
          fill: new Fill({ color: "rgba(185, 109, 44, 0.8)" }),
          stroke: new Stroke({ color: "white", width: 2 }),
        }),
        text: new Text({
          text: "\uf134",
          scale: 0.8,
          font: '900 15px "Font Awesome 5 Free"',
          offsety: -10,
          offsetx: -10,
          textAlign: "center",
          fill: new Fill({ color: "white" }),
        }),
      }),
      fire: [
        new Style({
          fill: new Fill({ color: "rgba(255, 0, 0, 0.3)" }),
        }),
        new Style({
          fill: new FillPattern({
            pattern: "gravel",
            color: "rgba(255, 255, 255, 0.6)",
            size: 12,
            spacing: 4,
            angle: 45,
          }),
          stroke: new Stroke({ color: "rgba(255, 0, 0, 0.8)", width: 2 }),
          text: new Text({
            text: `\uf06d`,
            scale: 1.2,
            font: '900 15px "Font Awesome 5 Free"',
            offsety: -10,
            offsetx: -10,
            textAlign: "center",
            fill: new Fill({ color: "white" }),
          }),
        }),
      ],
      route: new Style({
        stroke: new Stroke({ color: "rgba(247, 0, 255, 1)", width: 4 }),
      }),
      shortest_route: new Style({
        stroke: new Stroke({ color: "rgba(247, 70, 85, 1)", width: 4 }),
      }),
    };

    if (!data) return;

    const geojsonFormat = new GeoJSON();

    const pharmacies = data.features.filter(
      (feature) =>
        feature.properties?.amenity === "pharmacy" ||
        feature.properties?.healthcare === "pharmacy"
    );

    const hospitals = data.features.filter(
      (feature) =>
        feature.properties?.amenity === "hospital" ||
        feature.properties?.healthcare === "hospital" ||
        feature.properties?.amenity === "clinic" ||
        feature.properties?.healthcare === "clinic"
    );

    const fireStations = data.features.filter(
      (feature) =>
        feature.properties?.amenity === "fire_station"
    );

    const fireExtinguishers = data.features.filter(
      (feature) =>
        feature.properties?.emergency === "fire_extinguisher"
    );

    const pharmaciesGeoJSON = {
      type: "FeatureCollection",
      features: pharmacies,
    };

    const hospitalsGeoJSON = {
      type: "FeatureCollection",
      features: hospitals,
    };

    const fireStationsGeoJSON = {
      type: "FeatureCollection",
      features: fireStations,
    };

    const fireExtinguishersGeoJSON = {
      type: "FeatureCollection",
      features: fireExtinguishers,
    };


    pharmaciesRef.current = new VectorSource({
      features: geojsonFormat.readFeatures(pharmaciesGeoJSON, {
        featureProjection: "EPSG:3857",
      }),
    });

    hospitalsRef.current = new VectorSource({
      features: geojsonFormat.readFeatures(hospitalsGeoJSON, {
        featureProjection: "EPSG:3857",
      }),
    });

    fireStationsRef.current = new VectorSource({
      features: geojsonFormat.readFeatures(fireStationsGeoJSON, {
        featureProjection: "EPSG:3857",
      }),
    });

    fireExtinguishersRef.current = new VectorSource({
      features: geojsonFormat.readFeatures(fireExtinguishersGeoJSON, {
        featureProjection: "EPSG:3857",
      }),
    });


    fireRef.current = new VectorSource();

    const vectorLayerPharmacies = new VectorLayer({
      source: pharmaciesRef.current,
      title: `<div style="color:rgb(103,161,43)"><i class="fas fa-first-aid"></i>OSM - Pharmacies</div>`,
      displayInLayerSwitcherImage: false,
      visible: false,
      style: featureStyles["pharmacy"],
      zIndex: 9999,
    });

    const vectorLayerHospitals = new VectorLayer({
      source: hospitalsRef.current,
      title: `<div style="color:rgb(195, 166, 0)"><i class="fas fa-clinic-medical"></i>OSM - Hospitals / Clinics</div>`,
      displayInLayerSwitcherImage: false,
      visible: false,
      style: featureStyles["hospital"],
      zIndex: 9999,
    });

    // const vectorLayerFireStations = new VectorLayer({
    //   source: fireStationsRef.current,
    //   title: `<div style="color:rgb(0, 0, 255)"><i class="fas fa-burn"></i></i> Fire Stations</div>`,
    //   displayInLayerSwitcherImage: false,
    //   visible: true,
    //   style: featureStyles["fire_station"],
    //   zIndex: 9999,
    // });

    // const vectorLayerFireExtinguishers = new VectorLayer({
    //   source: fireExtinguishersRef.current,
    //   title: `<div style="color:rgb(185, 109, 44)"><i class="fas fa-fire-extinguisher"></i> Fire Extinguishers</div>`,
    //   displayInLayerSwitcherImage: false,
    //   visible: true,
    //   style: featureStyles["fire_extinguisher"],
    //   zIndex: 9999,
    // });

    // const vectorLayerFire = new VectorLayer({
    //   source: fireRef.current,
    //   displayInLayerSwitcher: false,
    //   displayInLayerSwitcherImage: false,
    //   style: featureStyles["fire"],
    //   zIndex: 999,
    // });

    // const vectorLayerRoute = new VectorLayer({
    //   source: new VectorSource(),
    //   title: `<div style="color:rgba(247, 0, 255, 1)"><i class="fas fa-route"></i> Route</div>`,
    //   displayInLayerSwitcher: true,
    //   displayInLayerSwitcherImage: false,
    //   visible: true,
    //   style: featureStyles["route"],
    //   zIndex: 999,
    // });

    mapRef.current.addLayer(vectorLayerPharmacies);
    mapRef.current.addLayer(vectorLayerHospitals);
    // mapRef.current.addLayer(vectorLayerFireStations);
    // mapRef.current.addLayer(vectorLayerFireExtinguishers);
    // mapRef.current.addLayer(vectorLayerFire);
    // mapRef.current.addLayer(vectorLayerRoute);

    const drawPolygonInteraction = new Draw({ type: "Polygon" });
    const drawPointInteraction = new Draw({ type: "Point" });
    const drawLineInteraction = new Draw({ type: "LineString", freehand: true });
    const selectToModify = new Select();
    const modifyInteraction = new Modify({ features: selectToModify.getFeatures() });
    const translateInteraction = new Translate();

    const deleteDialogContent = `
          <h2>Confirm Deletion</h2>
          <p>Are you sure you want to delete the selected feature?</p>
          <button id="cancel-btn" style="position: absolute; right: 20px; cursor: pointer;">Cancel</button>
          <button id="confirm-btn" style="position: absolute; right: 100px; cursor: pointer;">Delete</button>
        `;

    const selectToDelete = new Select();
    let selectedDeleteFeature = null;

    const deleteDialog = new Dialog({
      content: deleteDialogContent,
      closeBox: false,
    });

    mapRef.current.addControl(deleteDialog);

    selectToDelete.on('select', (e) => {
      selectedDeleteFeature = e.selected[0];
      logger.log('selected feature for delete: ', selectedDeleteFeature);
      // logger.log(selectedDeleteFeature);
      if (selectedDeleteFeature) {
        deleteDialog.show();
        setShowDialog(true);
        setHoverLock(true);
      }
    });

    // Ensure the dialog listens for Escape key
    // deleteDialog.on('keydown', (event) => {
    //   if (event.key === 'Escape') {
    //     deleteDialog.hide();
    //     setShowDialog(false);
    //     setHoverLock(false);
    //     deactivateAllToggles();
    //   }
    // });

    const handleDeleteSelection = (e) => {
      selectedDeleteFeature = e.selected[0];
      logger.log(selectedDeleteFeature);
      if (selectedDeleteFeature) {
        deleteDialog.show(); // Show the delete confirmation dialog
        setShowDialog(true);
        setHoverLock(true);
      }
    };

    const handleDeleteDialogClose = () => {
      selectedDeleteFeature = null; // Reset the selected feature when the dialog is closed
    };

    // Function to handle document click events for delete confirmation
    const handleDeleteClick = async (event) => {
      if (deleteToggle.getActive() && selectedDeleteFeature) { // Access the delete toggle through the toggles array
        if (event.target.id === 'confirm-btn') {
          const featureId = selectedDeleteFeature.values_.id

          const response = await api.delete(`/map/feature/${featureId}`)
          if (response.status !== 204 && response.status !== 200) {
            window.alert("Failed to delete, please try again!");
          }

          const updatedFeatures = await fetchFeatures();
          setFeatures(updatedFeatures);

          // Hide the dialog and reset the toggle and interaction
          deleteDialog.hide();
          deactivateAllToggles();
          deleteToggle.setActive(false); // Deactivate delete toggle
          
          selectedDeleteFeature = null; // Reset the selected feature
        } else if (event.target.id === 'cancel-btn') {
          deleteDialog.hide(); // Hide the dialog on cancel
          deactivateAllToggles(); // Remove interaction
          deleteToggle.setActive(false); // Deactivate delete toggle
          
          selectedDeleteFeature = null;
        }
      }
    };

    const addSourceButton = new Button({
      html: '<i class="fas fa-map"></i>',
      title: 'Add Source',
      handleClick: () => {        
        // Iterate over all overlays in the map
        mapRef.current.getOverlays().forEach(function (overlay) {
          if (overlay instanceof Dialog) {
            overlay.hide();
          }
        });
         
        deactivateAllToggles();  // Deactivate other toggles
        setDialogOpen(true);
        setHoverLock(true);  // Lock hover info
        generateSourceDialog(mapRef.current, () => {
          setDialogOpen(false);  
          setHoverLock(false);
        });
      }
    });

    // Add hover events to addSourceButton
    addSourceButton.element.addEventListener('mouseenter', () => {
      // Check if hoverLock is false (dialog is not open), then show the hover info
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo(`
          <i class="fas fa-map"></i> 
          <strong>Add Source:</strong> Click to open a dialog where you can add a new data source to the map. This could be a vector layer or an external data feed. You can configure:
          <ul>
            <li><strong>Title and Description:</strong> Provide information to identify the source.</li>
            <li><strong>Projection:</strong> Select the coordinate system for proper map alignment.</li>
            <li><strong>Type:</strong> Specify the source category, e.g., Vector.</li>
            <li><strong>Attribution:</strong> Acknowledge the data provider or owner.</li>
            <li><strong>Viewer Permissions:</strong> Set who can view the source on the map.</li>
          </ul>
        `);
      }
    });

    // Add mouseleave event to addSourceButton
    addSourceButton.element.addEventListener('mouseleave', () => {
      // Reset hover info only if hoverLock is false (dialog is not open)
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo('<strong>Hover over a button to see its details</strong>');
      }
    });

    const editSourceButton = new Button({
      html: '<i class="fas fa-edit"></i>',
      title: 'Edit Source',
      className: "section",
      handleClick: () => {
        deactivateAllToggles();  // Deactivate other toggles
        setDialogOpen(true);  // Mark dialog as open        
        setHoverLock(true);  // Lock hover info
        generateEditSourceDialog(mapRef.current, () => {
          setDialogOpen(false);  // Close dialog and update state
          setHoverLock(false);
        });
      }
    });

    // Add hover events to editSourceButton
    editSourceButton.element.addEventListener('mouseenter', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo(`
          <i class="fas fa-edit"></i> 
          <strong>Edit Source:</strong> Click to open a dialog for editing existing data sources on the map. You can modify:
          <ul>
            <li><strong>Title and Description:</strong> Update the source information.</li>
            <li><strong>Projection:</strong> Change the coordinate system, if needed.</li>
            <li><strong>Type:</strong> Modify the source type, e.g., Vector or other categories.</li>
            <li><strong>Attribution:</strong> Adjust attribution details.</li>
            <li><strong>Viewer Permissions:</strong> Manage who can view the source.</li>
            <li><strong>Enable/Disable:</strong> Toggle the source visibility on the map.</li>
          </ul>
        `);
      }
    });

    editSourceButton.element.addEventListener('mouseleave', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo('<strong>Hover over a button to see its details</strong>');
      }
    });

    const addLayerButton = new Button({
      html: '<i class="fas fa-layer-group"></i>',
      title: 'Add Layer',
      handleClick: () => {

        deactivateAllToggles();
        setDialogOpen(true);  // Mark dialog as open
        setHoverLock(true);  // Lock hover info
        generateLayerDialog(mapRef.current, () => {
          setDialogOpen(false);
          setHoverLock(false);
        });
      }
    });

    // Add hover events to addLayerButton
    addLayerButton.element.addEventListener('mouseenter', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        setHoveredButtonInfo(`
          <i class="fas fa-layer-group"></i> 
          <strong>Add Layer:</strong> Click to open a dialog for adding a new map layer. This allows you to visualize geographic data on the map by configuring:
          <ul>
            <li><strong>Title and Description:</strong> Identify the layer and its purpose.</li>
            <li><strong>Source:</strong> Select the source of data for the layer.</li>
            <li><strong>Icon:</strong> Choose an icon to represent the layer.</li>
            <li><strong>Line Style:</strong> Set line styles for visualizing features like roads or boundaries.</li>
            <li><strong>Pattern and Colors:</strong> Define fill patterns and colors for areas.</li>
            <li><strong>Opacity:</strong> Adjust the layer's transparency.</li>
            <li><strong>Viewer Permissions:</strong> Manage who can see the layer.</li>
          </ul>
        `);
      }
    });

    addLayerButton.element.addEventListener('mouseleave', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        setHoveredButtonInfo('<strong>Hover over a button to see its details</strong>');
      }
    });

    const editLayerButton = new Button({
      html: '<i class="fas fa-edit"></i>',
      title: 'Edit Layer',
      className: "section",
      handleClick: () => {

        deactivateAllToggles();
        setDialogOpen(true);  // Mark dialog as open
        setHoverLock(true);  // Lock hover info
        generateEditLayerDialog(mapRef.current, () => {
          setDialogOpen(false);
          setHoverLock(false);
        });
      }
    });

    // Add hover events to editLayerButton
    editLayerButton.element.addEventListener('mouseenter', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        setHoveredButtonInfo(`
          <i class="fas fa-edit"></i> 
          <strong>Edit Layer:</strong> Click to open a dialog for modifying an existing map layer. You can update:
          <ul>
            <li><strong>Title and Description:</strong> Revise the layer's information.</li>
            <li><strong>Source:</strong> Change the data source for the layer.</li>
            <li><strong>Icon:</strong> Modify the icon representing the layer.</li>
            <li><strong>Line Style and Pattern:</strong> Update line styles and fill patterns.</li>
            <li><strong>Colors and Opacity:</strong> Change the layer's visual properties.</li>
            <li><strong>Enable/Disable:</strong> Toggle the layer's visibility on the map.</li>
          </ul>
        `);
      }
    });

    editLayerButton.element.addEventListener('mouseleave', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        setHoveredButtonInfo('<strong>Hover over a button to see its details</strong>');
      }
    });

    const drawPointToggle = new Toggle({
      html: '<i class="fa fa-map-marker-alt"></i>',
      className: "draw-point",
      title: "Draw Point",
      active: false,
      onToggle: function (active) {
        if (active) {
          // Activate the toggle and add the drawPointInteraction
          activateToggleHelper(drawPointToggle, drawPointInteraction);
        } else {
          // Deactivate all toggles and interactions
          deactivateAllToggles();
        }
      },
    });
    

    // Add hover events to drawPointToggle
    drawPointToggle.element.addEventListener('mouseenter', () => {
      if (!hoverLockRef.current && !showDialogRef.current) { // Only change hover info if hoverLock is not active
        setHoveredButtonInfo('<i class="fa fa-map-marker-alt"></i> <strong>Draw Point:</strong> Use this tool to add a single point on the map, representing a specific location like a marker or a landmark. Click the "Draw Point" button to activate it. Then click on the map to place a point at the desired location. After placing the point, a dialog box will open where you can provide additional information, such as a name or description for the point.');
      }
    });

    drawPointToggle.element.addEventListener('mouseleave', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        setHoveredButtonInfo('<strong>Hover over a button to see its details</strong>');
      }
    });

    const drawLineToggle = new Toggle({
      html: '<i class="fas fa-wave-square"></i>',
      className: "draw-line",
      title: "Draw Line",
      active: false,
      onToggle: function (active) {

        if (active) {
          activateToggleHelper(drawLineToggle, drawLineInteraction);          
        } else {                    
          deactivateAllToggles(drawLineToggle);
        }
      },
    });

    // Add hover events to drawLineToggle
    drawLineToggle.element.addEventListener('mouseenter', () => {
      if (!hoverLockRef.current && !showDialogRef.current) { // Only update hover info if hoverLock is not active
        setHoveredButtonInfo('<i class="fas fa-wave-square"></i> <strong>Draw Line:</strong> This tool allows you to draw lines on the map, which can represent paths, roads, or boundaries. How to use: Activate the "Draw Line" button. Click on the map to start the line and continue clicking to add segments. Double-click to finish the line. A dialog box will open for you to enter details about the line (e.g., name or description).');
      }
    });

    drawLineToggle.element.addEventListener('mouseleave', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        setHoveredButtonInfo('<strong>Hover over a button to see its details</strong>');
      }
    });

    const drawPolygonToggle = new Toggle({
      html: '<i class="fa fa-draw-polygon" aria-hidden="true"></i>',
      className: "draw-polygon",
      title: "Draw Polygon",
      active: false,
      onToggle: function (active) {

        if (active) {
          activateToggleHelper(drawPolygonToggle, drawPolygonInteraction);          
        } else {                   
          deactivateAllToggles();
        }
      },
    });

    // Add hover events to drawPolygonToggle
    drawPolygonToggle.element.addEventListener('mouseenter', () => {
      if (!hoverLockRef.current && !showDialogRef.current) { // Only update hover info if hoverLock is not active
        setHoveredButtonInfo('<i class="fa fa-draw-polygon"></i> <strong>Draw Polygon:</strong> This tool lets you draw polygons, which are closed shapes on the map, useful for marking areas. How to use: Click the "Draw Polygon" button to activate it. Click on the map to place the corners of the polygon. Double-click to close the shape. A dialog box will appear for you to enter information about the polygon, like its name or purpose.');
      }
    });

    drawPolygonToggle.element.addEventListener('mouseleave', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        setHoveredButtonInfo('<strong>Hover over a button to see its details</strong>');
      }
    });

    const uploadFileButton = new Button({
      html: '<i class="fa fa-upload"></i>',
      title: "Upload File",
      className: 'section',
      handleClick: function () {
        deactivateAllToggles();
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".geojson,.kml,.gpx";

        const onWindowFocus = () => {
          window.removeEventListener('focus', onWindowFocus);
          if (!input.files.length) {
            setShowDialog(false); // Close dialog if no file is selected
            setHoverLock(false);  // Unlock hover info when dialog closes
          }
        };

        window.addEventListener('focus', onWindowFocus);

        input.onchange = async (e) => {
          const file = e.target.files[0];
          const format = file.name.split(".").pop().toLowerCase();
          let features;

          const reader = new FileReader();
          reader.readAsText(file, "UTF-8");
          reader.onload = async (readerEvent) => {
            const content = readerEvent.target.result;
            try {
              switch (format) {
                case "geojson":
                  features = new GeoJSON().readFeatures(content, { featureProjection: mapRef.current.getView().getProjection() });
                  break;
                case "kml":
                  features = new KML().readFeatures(content, { featureProjection: mapRef.current.getView().getProjection() });
                  break;
                case "gpx":
                  features = new GPX().readFeatures(content, { featureProjection: mapRef.current.getView().getProjection() });
                  break;
                default:
                  const errorDialog = new Dialog({
                    content: `<div><h3>Unsupported file format</h3><p>Supported formats: <strong>GeoJSON, KML, GPX</strong></p></div>`,
                    closeBox: true,
                  });
                  mapRef.current.addControl(errorDialog);
                  errorDialog.show();
                  return;
              }
              await handleFileUploadDialog(mapRef.current, features, setFeatures);
            } catch (error) {
              const errorDialog = new Dialog({
                content: `<div><h3>Error processing the file</h3></div>`,
                closeBox: true,
              });
              mapRef.current.addControl(errorDialog);
              errorDialog.show();
              setHoverLock(false);
              setShowDialog(false);
            }
          };
        };

        input.click();
        setShowDialog(true);  // Show dialog when file input opens
        setHoverLock(true);   // Lock hover info when dialog opens
      },
    });

    // Add hover events to uploadFileButton
    uploadFileButton.element.addEventListener('mouseenter', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo('<i class="fa fa-upload"></i> <strong>Upload File:</strong> This tool allows you to upload a file that contains map features (like points, lines, or polygons) from a file in GeoJSON, KML, or GPX format. Click the "Upload File" button. Select a file from your computer (supported formats: GeoJSON, KML, GPX). The map will automatically display the features from your file. You can edit the uploaded features through the available editing tools.');
      }
    });

    uploadFileButton.element.addEventListener('mouseleave', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo('<strong>Hover over a button to see its details</strong>');
      }
    });

    const translateToggle = new Toggle({
      html: '<i class="fa fa-arrows-alt" aria-hidden="true"></i>',
      title: "Move Feature",
      active: false,
      onToggle: function (active) {

        if (active) {
          activateToggleHelper(translateToggle, translateInteraction);          
        } else {                    
          deactivateAllToggles();
        }
      },
    });

    // Add hover events to translateToggle
    translateToggle.element.addEventListener('mouseenter', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo('<i class="fa fa-arrows-alt"></i> <strong>Move Feature:</strong> Move existing map features (points, lines, polygons) to new locations. Click Move Feature. Select a feature on the map and drag it to a new location. Release the mouse to save the new position.');
      }
    });

    translateToggle.element.addEventListener('mouseleave', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo('<strong>Hover over a button to see its details</strong>');
      }
    });

    translateInteraction.on('translateend', async function (event) {
      const feature = event.features.item(0);
      logger.log("Translated Feature Id: ", feature);
      const featureId = feature.values_.id;
      const newGeometry = feature.getGeometry();
      const geometryType = newGeometry.getType();
      let transformedCoordinates;

      if (geometryType === 'Point') {
        // For Point geometry, directly transform the coordinates
        const newCoords = newGeometry.getCoordinates();
        transformedCoordinates = transform(newCoords, 'EPSG:3857', 'EPSG:4326');
      } else if (geometryType === 'LineString') {
        // For LineString geometry, transform each coordinate pair
        const newCoords = newGeometry.getCoordinates();
        transformedCoordinates = newCoords.map(coord => transform(coord, 'EPSG:3857', 'EPSG:4326'));
      } else if (geometryType === 'Polygon') {
        // For Polygon geometry, you need to transform each ring
        const newCoords = newGeometry.getCoordinates();  // Array of arrays for polygons
        transformedCoordinates = newCoords.map(ring => ring.map(coord => transform(coord, 'EPSG:3857', 'EPSG:4326')));
      } else if (geometryType === 'MultiPolygon') {
        // For MultiPolygon geometry, transform each polygon's rings
        const newCoords = newGeometry.getCoordinates();
        transformedCoordinates = newCoords.map(polygon =>
          polygon.map(ring => ring.map(coord => transform(coord, 'EPSG:3857', 'EPSG:4326')))
        );
      }

      const updatedGeom = {
        type: geometryType,
        coordinates: transformedCoordinates
      }
      logger.log('Updated Geometry: ', JSON.stringify(updatedGeom, null, 2));
      try {
        const response = await api.patch(`/map/feature/${featureId}/`, {
          geometry: updatedGeom
        });
        if (response.status !== 204 && response.status !== 200) throw new Error('Failed to Translate feature');
      } catch (error) {
        logger.error(error);
        window.alert(error.message);
      }
      const updatedFeatures = await fetchFeatures();
      setFeatures(updatedFeatures);           
      
      deactivateAllToggles();
    });

    const modifyToggle = new Toggle({
      html: '<i class="fa fa-edit" aria-hidden="true"></i>',
      className: "modify-feature",
      title: "Modify Feature",
      active: false,
      onToggle: function (active) {

        if (active) {
          if (!mapRef.current.getInteractions().getArray().includes(modifyInteraction)) {
            activateToggleHelper(modifyToggle, modifyInteraction); 
          }
          
          // Ensure `selectToModify` is added
          if (!mapRef.current.getInteractions().getArray().includes(selectToModify)) {
            mapRef.current.addInteraction(selectToModify);
          }
        } else {                    
          deactivateAllToggles();
        }
      },
    });

    // Add hover events to modifyToggle
    modifyToggle.element.addEventListener('mouseenter', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo('<i class="fa fa-edit"></i> <strong>Modify Feature:</strong> Reshape existing map features. How to Use: Click Modify Feature. Select a feature to display its markers. Drag the markers to adjust the shape. Release the mouse to save changes.');
      }
    });

    modifyToggle.element.addEventListener('mouseleave', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo('<strong>Hover over a button to see its details</strong>');
      }
    });

    modifyInteraction.on("modifyend", async function (event) {
      // event.features.forEach((feature) => {
      //   const newCoords = feature.getGeometry().getCoordinates();
      //   const featureId = feature.getId();
      //   const index = avoidUserPolygons.findIndex((feature) => feature.getId() === featureId);
      //   if (index !== -1) {
      //     avoidUserPolygons[index].getGeometry().setCoordinates(newCoords);
      //   }
      // });

      const feature = event.features.item(0);
      logger.log("Translated Feature Id: ", feature);
      const featureId = feature.values_.id;
      const newGeometry = feature.getGeometry();
      const geometryType = newGeometry.getType();
      let transformedCoordinates;

      if (geometryType === 'Point') {
        // For Point geometry, directly transform the coordinates
        const newCoords = newGeometry.getCoordinates();
        transformedCoordinates = transform(newCoords, 'EPSG:3857', 'EPSG:4326');
      } else if (geometryType === 'LineString') {
        // For LineString geometry, transform each coordinate pair
        const newCoords = newGeometry.getCoordinates();
        transformedCoordinates = newCoords.map(coord => transform(coord, 'EPSG:3857', 'EPSG:4326'));
      } else if (geometryType === 'Polygon') {
        // For Polygon geometry, you need to transform each ring
        const newCoords = newGeometry.getCoordinates();  // Array of arrays for polygons
        transformedCoordinates = newCoords.map(ring => ring.map(coord => transform(coord, 'EPSG:3857', 'EPSG:4326')));
      } else if (geometryType === 'MultiPolygon') {
        // For MultiPolygon geometry, transform each polygon's rings
        const newCoords = newGeometry.getCoordinates();
        transformedCoordinates = newCoords.map(polygon =>
          polygon.map(ring => ring.map(coord => transform(coord, 'EPSG:3857', 'EPSG:4326')))
        );
      }

      const updatedGeom = {
        type: geometryType,
        coordinates: transformedCoordinates
      }
      logger.log('Updated Geometry: ', JSON.stringify(updatedGeom, null, 2));
      try {
        const response = await api.patch(`/map/feature/${featureId}/`, {
          geometry: updatedGeom
        });
        if (response.status !== 204 && response.status !== 200) throw new Error('Failed to Modify feature');
      } catch (error) {
        logger.error(error);
        throw error;
      }
      const updatedFeatures = await fetchFeatures();
      setFeatures(updatedFeatures);
      deactivateAllToggles();

    });

    const editToggle = new Toggle({
      html: '<i class="fas fa-cogs" aria-hidden="true"></i>',
      title: 'Edit',
      active: false,
      onToggle: (active) => {
        if (active) {
          // Ensure no duplicate event listeners
          selectToEdit.un('select', handleFeatureEditSelection);
          
          if (!mapRef.current.getInteractions().getArray().includes(selectToEdit)) {
            activateToggleHelper(editToggle, selectToEdit);
            
            selectToEdit.on('select', handleFeatureEditSelection);
          }    
        } else {
          // Properly remove listener when deactivating the toggle
          selectToEdit.un('select', handleFeatureEditSelection);
          deactivateAllToggles();
        }
      },
    });
    
    // Define the function outside to ensure it's used consistently
    const handleFeatureEditSelection = async (event) => {
      const selectedFeature = event.selected[0];

      if (selectedFeature) {
        await generateDialog(
          mapRef.current,
          selectedFeature,
          featureStyles,
          setFeatures,
          'edit',
          selectToEdit,
          selectToViewRef.current,
          editToggle,
        );
      }
    };    

    // Add hover events to editToggle
    editToggle.element.addEventListener('mouseenter', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo('<i class="fas fa-cogs"></i> <strong>Edit:</strong> Click to enter editing mode, allowing you to modify the properties of features on the map, such as name, description, or custom attributes.');
      }
    });

    editToggle.element.addEventListener('mouseleave', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo('<strong>Hover over a button to see its details</strong>');
      }
    });

    const deleteToggle = new Toggle({
      html: '<i class="fa fa-trash" aria-hidden="true"></i>',
      title: 'Delete',
      active: false,
      onToggle: (active) => {
        if (active) {
          if (!mapRef.current.getInteractions().getArray().includes(selectToDelete)) {

            activateToggleHelper(deleteToggle, selectToDelete);          
            
            // Attach listeners as needed.
            selectToDelete.on('select', handleDeleteSelection);
            document.addEventListener('click', handleDeleteClick);

            deleteDialog.on('close', handleDeleteDialogClose);
          }      
        } else {         

          selectToDelete.un('select', handleDeleteSelection);
          document.removeEventListener('click', handleDeleteClick);
          deleteDialog.un('close', handleDeleteDialogClose);

          deactivateAllToggles();
        }
      },
    });   

    // Add hover events to deleteToggle
    deleteToggle.element.addEventListener('mouseenter', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo('<i class="fa fa-trash"></i> <strong>Delete:</strong> Click to enter delete mode, allowing you to remove features from the map. Select a feature and confirm deletion.');
      }
    });

    deleteToggle.element.addEventListener('mouseleave', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo('<strong>Hover over a button to see its details</strong>');
      }
    });

    //Draw Point Interactions 

    drawPointInteraction.on("drawstart", function () {
      // Disable selectToView when the drawing starts
      if (selectToViewRef.current) {
        mapRef.current.removeInteraction(selectToViewRef.current);
      }
    });

    drawPointInteraction.on("drawend", async function (event) {
      await generateDialog(
        mapRef.current,
        event,
        featureStyles,
        setFeatures,
        "drawing",
      );
      deactivateAllToggles();
    });

    //Draw Line interactions

    drawLineInteraction.on("drawstart", function () {
      // Disable selectToView when the drawing starts
      if (selectToViewRef.current) {
        mapRef.current.removeInteraction(selectToViewRef.current);
      }
    });

    drawLineInteraction.on("drawend", async function (event) {
      await generateDialog(
        mapRef.current,
        event,
        featureStyles,
        setFeatures,
        "drawing"
      );
      deactivateAllToggles();
    });

    //Draw Polygon Interactions

    let avoidUserPolygons = [];

    // Disable selectToViewRef when drawing starts
    drawPolygonInteraction.on('drawstart', function () {
      if (selectToViewRef.current) {
        mapRef.current.removeInteraction(selectToViewRef.current);
      }
    });

    // Enable selectToViewRef after drawing ends
    drawPolygonInteraction.on('drawend', async function (event) {
      await generateDialog(
        mapRef.current,
        event,
        featureStyles,
        setFeatures,
        'drawing'
      );
      deactivateAllToggles();
    });

    const selectToEdit = new Select({
      layers: function (layer) {
        // This function will return true for layers that are visible
        return layer.getVisible();
      },
      condition: click,  // This keeps the interaction based on click events
    });    

    const dateSelectionButton = new Button({
      html: '<i class="fas fa-calendar-alt"></i>',
      title: 'Date Picker',
      className: "section",
      active: false,
      handleClick: function () {
        deactivateAllToggles();

        const dialogContent = `
          <div>
            <label for="selected-date">Select Date:</label>
            <input type="date" id="selected-date" value="${selectedDate}">
            <br/><br/>
            <div style="cursor: pointer; display: inline-block; padding: 5px 10px; border: 1px solid; border-radius: 5px;" id="saveButton">
              <i class="fas fa-check"></i>Confirm
            </div>
          </div>
        `;

        const dateDialog = new Dialog({
          content: dialogContent,
          className: 'date-dialog',
          closeBox: false,
          onclose: function () {            
            deactivateAllToggles();
          }
        });

        // Ensure the dialog listens for Escape key
        // dateDialog.on('keydown', (event) => {
        //   if (event.key === 'Escape') {
        //     deleteDialog.hide();
        //     setShowDialog(false);
        //     setHoverLock(false);
        //     deactivateAllToggles();
        //   }
        // });

        mapRef.current.addControl(dateDialog);

        // Wait for the dialog to be added to the DOM
        setTimeout(() => {
          const dialogForm = dateDialog.element.querySelector('form');

          if (dialogForm) {
            // Remove the default class (if any specific one exists)
            dialogForm.classList.remove('form');

            // Add your custom class
            dialogForm.classList.add('date-form');
          }
        }, 0);

        dateDialog.element.className += ' date-dialog';

        const dialogElement = dateDialog.getContentElement();

        setShowDialog(true);
        setHoverLock(true);
        dateDialog.show();

        // Attach the event listener directly to the save button
        dialogElement.querySelector('#saveButton').addEventListener('click', function () {
          handleSaveButtonClick(dateDialog);
          dateDialog.hide();
          setHoverLock(false);
          setShowDialog(false);
        });
      },
    });

    // Handle hover logic with hoverLock
    dateSelectionButton.element.addEventListener('mouseenter', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo('<i class="fas fa-calendar-alt"></i> <strong>Date Picker</strong>: Click to open the date selection dialog, allowing you to choose a specific date for retrieving or viewing historical map data.');
      }
    });
    dateSelectionButton.element.addEventListener('mouseleave', () => {
      if (!hoverLockRef.current && !showDialogRef.current) {
        updateHoverButtonInfo('<strong>Hover over a button to see its details</strong>');
      }
    });

    const handleSaveButtonClick = (dialog) => {
      const inputElement = document.getElementById('selected-date');
      if (inputElement) {
        const inputDate = inputElement.value;
        if (inputDate) {
          let newDate = new Date(inputDate).toISOString().split('T')[0];
          logger.log("new date: ", newDate);
          setSelectedDate(newDate);
        }
        inputElement.remove();
        dialog.close();
        setHoverLock(false);
        setShowDialog(false);
      }
    };

    

    function deactivateAllToggles(exceptionToggle = null) {
      if (!mapRef.current) return;
    
      // Deactivate all toggles except the exception
      controls.forEach((control) => {
        if (control.setActive && control !== exceptionToggle) {
          control.setActive(false);
        }
      });
    
      // Remove all interactions except `selectToViewRef`
      [
        drawPointInteraction,
        drawLineInteraction,
        drawPolygonInteraction,
        modifyInteraction,
        translateInteraction,
        selectToModify,
        selectToEdit,
        selectToDelete,
      ].forEach((interaction) => {
        mapRef.current.removeInteraction(interaction);
      });
    
      // Clear features for selection interactions
      [selectToModify, selectToDelete, selectToEdit].forEach((selectInteraction) => {
        if (selectInteraction) {
          selectInteraction.getFeatures().clear();
        }
      });
    
      // Hide the popup overlay instead of removing it
      if (popupOverlayRef.current) {
        popupOverlayRef.current.setPosition(undefined); // Hide the popup
      }
    
      setHoverLock(false);
      setShowDialog(false);
    
      // Re-enable the `selectToViewRef` interaction if it is not already active
      if (
        selectToViewRef.current &&
        !mapRef.current.getInteractions().getArray().includes(selectToViewRef.current)
      ) {
        mapRef.current.addInteraction(selectToViewRef.current);
      }
    }
    

    function activateToggleHelper(toggle, interaction = null) {
      if (!toggle) {
        logger.error(`Toggle ${toggle} is undefined.`);
        return;
      }
    
      deactivateAllToggles(toggle); // Deactivate all toggles except the current one
    
      toggle.setActive(true);
    
      // Remove `selectToViewRef` only if the interaction conflicts with it
      if (
        selectToViewRef.current &&
        interaction &&
        interaction !== selectToViewRef.current
      ) {
        mapRef.current.removeInteraction(selectToViewRef.current);
      }
    
      // Add the specified interaction
      if (interaction) {
        if (!mapRef.current.getInteractions().getArray().includes(interaction)) {
          mapRef.current.addInteraction(interaction);
        }
      }
    
      setHoverLock(true);
      setShowDialog(true);
    }    

    //Control Bar//

    const controls = [
      dateSelectionButton,
      addSourceButton,
      editSourceButton,
      addLayerButton,
      editLayerButton,
      drawPointToggle,
      drawLineToggle,
      drawPolygonToggle,
      uploadFileButton,
      translateToggle,
      modifyToggle,
      editToggle,
      deleteToggle,
    ];    

    
    const baseControlBar = new ControlBar({
      controls: controls,
      orientation: "horizontal",
      className: "base-control-bar",
    });

    baseControlBar.setPosition("top-center");
    mapRef.current.addControl(baseControlBar);      
  
    const layerSwitcher = new LayerSwitcher({
      mouseover: false,
      reordering: true,
    });

    mapRef.current.addControl(layerSwitcher);    

  }, [point, range, location, selectedDate, data, features]); 

  return (
    <>
        {loading ? (
            <LoadingIcon />
        ) : data ? ( 
            <>
                <div id="map"></div>
                {mapRef.current && selectToViewRef.current && (
                    <FeaturePopup 
                        map={mapRef.current} 
                        selectInteraction={selectToViewRef.current} 
                        popupOverlayRef={popupOverlayRef} 
                    />
                )}
                <SideBar
                    mapRef={mapRef}
                    isLoggedIn={isLoggedIn}
                    setIsLoggedIn={setIsLoggedIn}
                    setHoveredButtonInfo={setHoveredButtonInfo}
                    toggleDrawer={toggleDrawer}
                />
                <div className={`information-container ${isDrawerOpen ? 'open' : ''}`}>
                    <div className="title"><h2>Instructions</h2></div>
                    <div className="information-content">
                        <p dangerouslySetInnerHTML={{ __html: hoveredButtonInfo }} />
                    </div>
                </div>
            </>
        ) : null} 
    </>
  );
};

export default UserDefinedData;
